/* eslint-disable */
import { Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import MetaTags from "ReusableComponents/MetaTags/MetaTags";
import { COLORS } from "theme";
import { sortData } from "utils";
import ContactSection from "./ContactSection";
import ContactUsHero from "./ContactUsHero";
import ContactUsInfo from "./ContactUsInfo";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const medium = useMediaQuery("(max-width: 900px)");
  const [bannerDetails, setBannerDetails] = useState([]);
  const [features, setFeatures] = useState([]);
  const [sections, setSections] = useState([]);
  const [info, setInfo] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    apiClient.getContactUsBanner().then((res) => {
      setBannerDetails(res?.data);
    });
    apiClient.getContactUsFeatures().then((res) => {
      setFeatures(res?.data);
    });
    apiClient.getContactUsInfo().then((res) => {
      setInfo(res?.data);
    });
    apiClient.getContactUsSections().then((res) => {
      setSections(sortData(res?.data));
    });
  }, []);
  return (
    <>
      <Grid item xs={12}>
        <ContactUsHero bannerDetails={bannerDetails} small={small} />
      </Grid>
      <Grid item xs={12} style={{ padding: 0 }}>
        <ContactUsInfo data={info} small={small} medium={medium} />
      </Grid>

      {sections.map((item, index) => {
        return (
          <Grid
            item
            xs={12}
            md={6}
            style={{ padding: 0, background: COLORS.lightBlack }}
            key={item?.id}
          >
            <ContactSection
              title={item?.attributes?.title}
              description={item?.attributes?.description}
              img={
                !small
                  ? item?.attributes?.media?.data[0]?.attributes?.url
                  : item?.attributes?.media_mobile?.data?.attributes?.url
              }
              alt={
                item?.attributes?.media?.data[0]?.attributes?.alternativeText
              }
              small={small}
            />
          </Grid>
        );
      })}
      <Helmet>
        <title>
          {t("Contact Us - Powerful Electric Cargo 3 Wheeler | Euler Motors")}
        </title>
        <meta
          name="title"
          content={t(
            "Contact Us - Powerful Electric Cargo 3 Wheeler | Euler Motors"
          )}
        />
        <meta
          name="description"
          content={t(
            "If you have any questions, concerns, or issues, feel free to reach out to Euler Motors' customer service team for assistance. We are here to help you."
          )}
        />
        ​
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.eulermotors.com/contact-us"
        />
        <meta property="og:title" content="Euler Motors | Contact Us" />
        <meta
          property="og:description"
          content="Euler Motors for Electric Commercial three wheeler - Contact us for corporate and customer queries."
        />
        <meta
          property="og:image"
          content="https://www.eulermotors.com/static/media/social_banner.png"
        />
        ​
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.eulermotors.com/contact-us"
        />
        <meta property="twitter:title" content="Euler Motors | Contact Us" />
        <meta
          property="twitter:description"
          content="Euler Motors for Electric Commercial three wheeler - Contact us for corporate and customer queries."
        />
        <meta
          property="twitter:image"
          content="https://www.eulermotors.com/static/media/social_banner.png"
        />
        <MetaTags link={"https://www.eulermotors.com/contact-us"} />
      </Helmet>
    </>
  );
};

export default ContactUs;
